/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CoursefinancialCoursesCourseidPlansId200,
  GetApiV1CoursefinancialCoursesCourseidPlansId401,
  GetApiV1CoursefinancialCoursesCourseidPlansId404,
  GetApiV1CoursefinancialCoursesCourseidPlansId500,
  GetApiV1CoursefinancialCoursesCourseidPlansIdPathParams,
  GetApiV1CoursefinancialCoursesCourseidPlansIdQueryResponse,
} from "../../types/courseFinancialRegistrationController/GetApiV1CoursefinancialCoursesCourseidPlansId.ts";
import { courseFinancialDetailViewModelSchema } from "../courseFinancialDetailViewModelSchema.ts";

export const getApiV1CoursefinancialCoursesCourseidPlansIdPathParamsSchema =
  z.object({
    courseId: z.coerce.number().int(),
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CoursefinancialCoursesCourseidPlansIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CoursefinancialCoursesCourseidPlansId200Schema = z.lazy(
  () => courseFinancialDetailViewModelSchema,
) as unknown as ToZod<GetApiV1CoursefinancialCoursesCourseidPlansId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CoursefinancialCoursesCourseidPlansId401Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursesCourseidPlansId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CoursefinancialCoursesCourseidPlansId404Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursesCourseidPlansId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CoursefinancialCoursesCourseidPlansId500Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursesCourseidPlansId500>;

export const getApiV1CoursefinancialCoursesCourseidPlansIdQueryResponseSchema =
  z.lazy(
    () => getApiV1CoursefinancialCoursesCourseidPlansId200Schema,
  ) as unknown as ToZod<GetApiV1CoursefinancialCoursesCourseidPlansIdQueryResponse>;
